var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpciones(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#6E7687",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2441 4304 c-253 -68 -410 -331 -346 -579 67 -256 329 -415 580 -350 190 50 330 207 358 401 48 331 -270 615 -592 528z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2441 3024 c-253 -68 -410 -331 -346 -579 67 -256 329 -415 580 -350 190 50 330 207 358 401 48 331 -270 615 -592 528z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2441 1744 c-253 -68 -410 -331 -346 -579 67 -256 329 -415 580 -350 190 50 330 207 358 401 48 331 -270 615 -592 528z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpciones);
export default __webpack_public_path__ + "static/media/opciones.7f03cbd4172440915415cda57ba28d2a.svg";
export { ForwardRef as ReactComponent };